/**
 * Opens the marketing /monitoring "build your system" drawer.
 */
export const MONITORING_SYSTEM_DRAWER_SEARCH_PARAM = "systemDrawer";

/** Default param value when the plan card has no `systemDrawerProduct` in Sanity. */
export const MONITORING_SYSTEM_DRAWER_DEFAULT_SLUG = "base-system";

export const COMPARE_MONITORING_PLANS_LABEL = "Compare monitoring plans";

export const COMPARE_ALL_PLAN_FEATURES_LABEL = "Compare all plan features";
